var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "target_2_",
    "data-name": "target (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.146,
    height: 17.146,
    viewBox: "0 0 17.146 17.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60523",
    "data-name": "Group 60523",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87725",
    "data-name": "Path 87725",
    d: "M16.512,1.684l-1.219.174L15.467.639a.56.56,0,0,0-.949-.474l-1.56,1.56a8.383,8.383,0,1,0,2.468,2.468l1.56-1.56A.56.56,0,0,0,16.512,1.684ZM13.2,3.06l.919-.919-.042.3a.559.559,0,0,0,.633.633l.3-.042-.919.919-1.034.148Zm.218,5.7A5.038,5.038,0,1,1,11.53,4.83l-.8.8a3.917,3.917,0,1,0,.791.791l.8-.8A5.007,5.007,0,0,1,13.423,8.76ZM8.391,7.083A1.678,1.678,0,1,0,9.9,8.037l.818-.818a2.8,2.8,0,1,1-.791-.791l-.818.818A1.666,1.666,0,0,0,8.391,7.083ZM8.95,8.76a.56.56,0,1,1-.167-.4l0,0,0,0A.557.557,0,0,1,8.95,8.76Zm6.709,0a7.265,7.265,0,1,1-3.485-6.207.559.559,0,0,0-.05.165l-.15,1.047a6.156,6.156,0,1,0,1.412,1.412l1.047-.15a.558.558,0,0,0,.165-.051A7.209,7.209,0,0,1,15.659,8.76Z",
    transform: "translate(-0.005 0)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.f768e65a1a03d74df0c0d767053f3a0d.svg";
export { ForwardRef as ReactComponent };